// L2b: the horse colour comes from the --accent-400 design token (tokens.css),
// so a theme change recolours every lottie horse without touching JS.
// Plain script + ES export: track.js (IIFE) uses window.tlAccentColor.

export const ACCENT_FALLBACK = '#60a5fa';

export function normalizeHex(v) {
  if (!v) return null;
  v = String(v).trim();
  let m = /^#([0-9a-f]{3})$/i.exec(v);
  if (m) return '#' + m[1].split('').map((c) => c + c).join('').toLowerCase();
  m = /^#([0-9a-f]{6})$/i.exec(v);
  if (m) return '#' + m[1].toLowerCase();
  m = /^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/i.exec(v);
  if (m) return '#' + [m[1], m[2], m[3]].map((n) => Math.min(255, +n).toString(16).padStart(2, '0')).join('');
  return null;
}

export function accentColor(token = '--accent-400', root) {
  try {
    const el = root || document.documentElement;
    const hex = normalizeHex(getComputedStyle(el).getPropertyValue(token));
    if (hex) return hex;
  } catch (e) { /* no DOM */ }
  return ACCENT_FALLBACK;
}

if (typeof window !== 'undefined') window.tlAccentColor = accentColor;
